import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import useMediaQuery from '@mui/material/useMediaQuery';
import Legend from './Legend';
import List from './List';

// Components

const Files: React.FC = () => {
    const isMobile = useMediaQuery('(max-width:768px)');

    return (

        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                width: '100%',
                // height: '75%', // Remove fixed height
                flexGrow: 1, // Allow this section to take available space
                overflow: 'hidden', // Parent handles outer scroll, List handles inner scroll
                paddingX: isMobile ? 0.5 : 0, // Reduce horizontal padding on mobile
            }}>

            <Legend /> 

            <List /> 
            
        </Box>

    );

};

export default Files;